// extracted by mini-css-extract-plugin
module.exports = {"container":"loadingPage_container__26caz","lds-default":"loadingPage_lds-default__moHyE"};